import http from '@/http'

export const adminGetPage = async (pageId) => {
  return http.get(`/admin/pages/${pageId}`)
}
